/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Add_Members_Partial_ErrorInputs */



/**
* | output |
* | --- |
* | "{failed} of {total} members failed to add." |
*
* @param {Spaces_Add_Members_Partial_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_members_partial_error = /** @type {((inputs: Spaces_Add_Members_Partial_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_Members_Partial_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.failed} von ${i?.total} Mitgliedern konnten nicht hinzugefügt werden.`)
	return /** @type {LocalizedString} */ (`${i?.failed} of ${i?.total} members failed to add.`)
});